import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddWalletPricing = () => {
  const [point, setPoint] = useState();
  const [value, setValue] = useState();
  const [bonus, setBonus] = useState();
  const [percentage, setpercentage] = useState();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddWalletPricing = () => {
    navigate("/add-wallet-pricing");
  };
  const handleViewAllWalletPricing = () => {
    navigate("/all-wallet-pricing");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(
        `${API_BASE_URL}/admin/pricing/bonus`,
        { point, value, bonus, percentage },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        console.log(res);
        alert("Wallet Price Added");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while adding Wallet price");
      });
  };
  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Wallet Pricing</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={handleAddWalletPricing}
            >
              + Add New Wallet Pricing
            </button>
            <button
              className="allSubjects"
              onClick={handleViewAllWalletPricing}
            >
              All Wallet Pricing
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Wallet Pricing Detail</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Point</label>
              </div>
              <input
                type="text"
                placeholder="Enter Point Code"
                value={point}
                onChange={(e) => setPoint(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Value</label>
              </div>
              <input
                type="text"
                placeholder="Enter Value Code"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Bonus</label>
              </div>
              <input
                type="text"
                placeholder="Enter Bonus Code"
                value={bonus}
                onChange={(e) => setBonus(e.target.value)}
                required
              />
            </div>
            
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Percentage</label>
              </div>
              <input
                type="text"
                placeholder="Enter Percentage"
                value={percentage}
                onChange={(e) => setpercentage(e.target.value)}
                required
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/all-wallet-pricing")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddWalletPricing;
